<template>
    <tr>
        <td class="editor-content editor-label">Tag</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.tag">
                <option>h1</option>
                <option>h2</option>
                <option>h3</option>
                <option>h4</option>
                <option>h5</option>
                <option>h6</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'TagEditor',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
